/**
 * lib/storefront/wick_guide/null_wick.js
 */

import BaseWick from './base-wick.js';

class NullWick extends BaseWick {
  constructor() {
    super('-', false);
  }

  get secondRow() {
    return this;
  }
}

export default NullWick;
